import * as Sentry from "@sentry/react";
import React from 'react';
import ReactDOM from 'react-dom/client';
import Quill from 'quill';
import type { Entries } from 'type-fest';

import '~/styles/index.scss';
import 'driver.js/dist/driver.css';

import { PointageLinkClass, PointageLinkFormat } from '~/components/Inputs/EmailTextEditor/PointageLink';
import Placeholder from '~/components/Inputs/EmailTextEditor/Placeholder';

import App from '~/App';

declare global {
  interface ObjectConstructor {
    entries<T extends object>(o: T): Entries<T>;
  }
}

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.replayIntegration(),
      Sentry.feedbackIntegration({
        autoInject: false,
        colorScheme: 'system',
        showBranding: false,
        triggerLabel: '',
        formTitle: 'Rapporter un bogue ou poser une question',
        submitButtonLabel: 'Soumettre',
        cancelButtonLabel: 'Annuler',
        confirmButtonLabel: 'Confirmer',
        addScreenshotButtonLabel: "Ajouter une capture d'écran",
        removeScreenshotButtonLabel: "Retirer la capture d'écran",
        nameLabel: 'Nom',
        namePlaceholder: 'Votre nom',
        emailLabel: 'Courriel',
        emailPlaceholder: 'Votre courriel',
        isRequiredLabel: '(requis)',
        messageLabel: 'Message',
        messagePlaceholder: 'Quel est le bogue? Quelle est votre question?',
        successMessageText: 'Merci! Nous vous répondrons sous peu.',
        isEmailRequired: true,
      }),
    ],
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    tunnel: '/api/v1/monitor',
  });
}

Quill.register({
  'attributors/class/pointage-link': PointageLinkClass,
  'formats/pointage-link': PointageLinkFormat,
  'formats/placeholder': Placeholder,
});

const element = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(element);
root.render(
  <Sentry.ErrorBoundary fallback={<p>Une erreur s&apos;est produite. Les administrateurs systèmes ont été avisés. Veuillez rafraîchir la page.</p>}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Sentry.ErrorBoundary>,
);
